// Since when the boat has been in its mode, for home's header (TOM-677), read
// from the boat's mode history (`GET /v1/boats/:id/mode/history`, ADR 0321)
// over the longest window it serves. Read again when the boat reports a new
// mode. Null while it loads, when it fails, and when the history doesn't say:
// the header then leaves the line out, never writes one of its own.

import { useEffect, useState } from 'react';

import { api } from '../api';
import { modeSince, type ModeHistoryReply } from './homeHeader';

/** The widest window the route reads (api_contracts §5.14). */
const WINDOW_MS = 92 * 86_400_000;

export function useModeSince(boatId: string, mode: string | null, key: string): string | null {
  const [since, setSince] = useState<string | null>(null);
  useEffect(() => {
    setSince(null);
    if (boatId === '' || mode === null) return;
    let alive = true;
    const from = new Date(Date.now() - WINDOW_MS).toISOString();
    api<ModeHistoryReply>(
      `/v1/boats/${encodeURIComponent(boatId)}/mode/history?from=${encodeURIComponent(from)}`
    )
      .then((history) => {
        if (alive) setSince(modeSince(history, mode));
      })
      .catch(() => {
        if (alive) setSince(null);
      });
    return () => {
      alive = false;
    };
  }, [boatId, mode, key]);
  return since;
}
